import { HttpClient } from '@angular/common/http';

import { Inject, Injectable } from '@angular/core';
import { Observable, forkJoin, map, of, switchMap, tap } from 'rxjs';
import { ITribesResponse } from '../shared/interfaces/tribe.interface';
import { CoursesService } from './courses.service';

@Injectable({
  providedIn: 'root',
})
export class TribesService {
  BASE_URL = 'https://backoffice.aprendity.com';
  // private http = Inject(HttpClient);
  constructor(private http:HttpClient,private courseService:CoursesService) { }


  getTribeById(id: string): Observable<ITribesResponse[]> {
    return this.http.get<any>(`${this.BASE_URL}/api/node/forum?sort=-created`).pipe(
      map(({ data }: any) => data)
    );

  // getTribeById(id: string): Observable<ITribes[]> {
  //   return this.http.get<any>(`${this.BASE_URL}/api/node/forum?sort=-created&filter[field_course.id][value]=${id}`).pipe(
  //     map(({ data }: any) => data)
  //   );


  }
  getTribesForAllCoursesEnrolled():Observable<any>{
    const profileUser = localStorage.getItem('current_user_edutegia');

    if (!profileUser) { console.log("Error: user not logged"); return of(null);};
    const { uid } = JSON.parse(profileUser);
    return this.courseService.isEnroll(uid).pipe(
      map((courses:any) => {
        // console.log('courses:', courses);
        const coursesId = courses.map((course:any) => course.id);
        // console.log('coursesId:', coursesId);
        return coursesId;
      }),
      switchMap((coursesId:any) => {
        const observables = coursesId.map((id:any) => this.getTribeById(id));
        return forkJoin(observables);
      })
    )
    // ,tap((c:any) => console.log("getTribesForAllCoursesEnrolled",c));

  }

}
